import { useCallback } from 'react';
import NiceModal from '@ebay/nice-modal-react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { includes } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import { getLabelMessage } from '@gef-ui/localization/messages';
import FileExport from '@gef-ui/material-icons/FileExport';
import Print from '@gef-ui/material-icons/Print';

import { ComponentLoader } from 'components';
import Subheader from 'components/atoms/GefMui/Subheader';
import ToolbarTemplate from 'components/atoms/GefMui/ToolbarTemplate/ToolbarTemplate';
import { EMPTY_VALUES, USER_ROLES } from 'constants/general';
import MODALS from 'constants/modals';
import acl from 'features/common/acl';
import fetch from 'features/common/fetch';
import contactList from 'features/views/contactList';
import { openDialogTooManyContactsForPrint } from 'features/views/contacts/actions';
import { getContacts } from 'features/views/contacts/selectors';
import { getCurrentRole } from 'features/views/user/selectors';
import { getRoutePath } from 'utils/routeHelper';

export const Toolbar = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const currentRole = useSelector(getCurrentRole);
	const fetchedContacts = useSelector(getContacts('list'));

	const handleReport = useCallback(() => {
		dispatch(contactList.actions.reportCampaign());
	}, [dispatch]);

	const handleTakeContact = useCallback(() => {
		NiceModal.show(MODALS.contact_take);
	}, []);

	const handlePrintButton = useCallback(() => {
		if (fetchedContacts.length > 50) {
			dispatch(openDialogTooManyContactsForPrint());
		} else {
			const { pathname, state } = getRoutePath('printContactsList', EMPTY_VALUES.OBJECT, true);
			state.view = 'list';
			navigate(pathname, { state });
		}
	}, [dispatch, navigate, fetchedContacts]);

	const subheaderToolbar = (
		<Stack direction="row" spacing={2}>
			{includes(currentRole, [USER_ROLES.SELLER, USER_ROLES.PPZ]) && (
				<AccessControl accessLevel={acl.constants.KMP_CONTACT_PROCESS}>
					<Button variant="text" size="small" onClick={handleTakeContact}>
						{getLabelMessage('contacts:takeContact')}
					</Button>
				</AccessControl>
			)}
			<ComponentLoader fetchStorePath={fetch.constants.urls.campaignReport} ignoreErrors>
				<Button variant="text" size="small" startIcon={<FileExport />} onClick={handleReport}>
					{getLabelMessage('contacts:report')}
				</Button>
			</ComponentLoader>
			<AccessControl accessLevel={acl.constants.KMP_CONTACT_PROCESS}>
				<Button
					variant="text"
					size="small"
					startIcon={<Print />}
					onClick={handlePrintButton}
					disabled={isNilOrEmpty(fetchedContacts)}
				>
					{getLabelMessage('common:print')}
				</Button>
			</AccessControl>
		</Stack>
	);

	return (
		<ToolbarTemplate
			leftSide={<Subheader title={getLabelMessage('contacts:title')} />}
			rightSide={subheaderToolbar}
		/>
	);
};

export default Toolbar;
